import React from "react";
import styles from "./payment.module.css";

export default function ExpressCheckout({
  supportsApplePay,
  supportsGooglePay,
  isApplePayLocked,
  isGooglePayLocked,
  appleLockSeconds,
  googleLockSeconds,
  applePayRef,
  googlePayRef,
}) {
  if (!supportsApplePay && !supportsGooglePay) return null;

  return (
    <section className={styles.expressSection} aria-label="Express checkout">
      <div className={styles.expressStack}>
        {supportsApplePay ? (
          <div className={styles.expressWallet}>
            {isApplePayLocked ? (
              <span className={styles.expressLock} role="status">
                Apple Pay locked · {appleLockSeconds}s
              </span>
            ) : null}
            <div
              ref={applePayRef}
              className={`${styles.expressMount} ${styles.expressMountApple}`}
              id="apple-pay-container"
            />
          </div>
        ) : null}
        {supportsGooglePay ? (
          <div className={styles.expressWallet}>
            {isGooglePayLocked ? (
              <span className={styles.expressLock} role="status">
                Google Pay locked · {googleLockSeconds}s
              </span>
            ) : null}
            <div
              ref={googlePayRef}
              className={`${styles.expressMount} ${styles.expressMountGoogle}`}
              id="google-pay-container"
            />
          </div>
        ) : null}
      </div>
    </section>
  );
}
